import directive from "./directive";

// useage:
// 在需要 loading 的元素上添加 v-loading = "boolean" 指令
export default {
  install(Vue) {
    Vue.use(directive);
  }
};
